import { jsx as o, jsxs as N, Fragment as _ } from "react/jsx-runtime";
import I, { useState as E } from "react";
import { withManagedProps as j } from "@made-people/managed-props";
import { z as i } from "zod";
import { withZod as k } from "@made-people/react-prop-guard";
import { sliderDresdenStyling as H, sliderSydneyStyling as M } from "./index-blueprint.es.js";
import "keen-slider/keen-slider.min.css";
import y from "clsx";
import { useLink as A } from "@made-people/grease-link";
import { useKeenSlider as W } from "keen-slider/react";
import "@made-people/blueprint";
const F = (r) => /* @__PURE__ */ o(
  "svg",
  {
    className: r.className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /* @__PURE__ */ o("path", { d: "m1.817 9.846 5.529-5.528a.515.515 0 0 1 .728.727l-4.65 4.65h14.394a.513.513 0 0 1 .515.515c0 .284-.23.515-.515.515H3.424l4.650 4.65a.515.515 0 1 1-.728.728l-5.529-5.529a.515.515 0 0 1 0-.728Z" })
  }
), T = F, Z = (r) => /* @__PURE__ */ o(
  "svg",
  {
    className: r.className,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /* @__PURE__ */ o("path", { d: "m18.182 10.574-5.528 5.529a.515.515 0 0 1-.728-.728l4.65-4.65H2.18a.514.514 0 1 1 0-1.03h14.395l-4.65-4.65a.515.515 0 0 1 .728-.727l5.528 5.528a.515.515 0 0 1 0 .728Z" })
  }
), L = Z, C = {
  loop: !0,
  mode: "snap",
  breakpoints: {
    mobile: { perView: 1.25, spacing: 8 },
    tablet: { perView: 2, spacing: 8 },
    laptop: { perView: 4, spacing: 8 }
  }
}, D = i.object({
  children: i.custom().optional(),
  variants: i.custom().optional(),
  template: i.literal("dresden"),
  content: i.object({
    heading: i.string().optional(),
    link: i.object({ href: i.string() }).optional(),
    linkLabel: i.string().optional()
  }).optional(),
  features: i.object({
    /**
     * Defines the placement of the navigation buttons (default is "slider").
     */
    navigationPlacement: i.union([i.literal("header"), i.literal("slider")]).optional(),
    headingTag: i.union([
      i.literal("h1"),
      i.literal("h2"),
      i.literal("h3"),
      i.literal("h4"),
      i.literal("h5"),
      i.literal("h6")
    ]).optional(),
    icons: i.object({
      previous: i.custom().optional(),
      next: i.custom().optional()
    }).optional()
  }).optional()
}), R = ({
  previousIcon: r,
  nextIcon: h,
  slots: l,
  appearIn: a,
  location: e
}) => {
  const { instanceRef: s, loaded: u } = B(), c = r ?? T, p = h ?? L;
  return a !== e ? null : /* @__PURE__ */ o("div", { className: l.navigationButtonsWrapper, children: u && s.current && /* @__PURE__ */ N(_, { children: [
    /* @__PURE__ */ o(
      "button",
      {
        onClick: (m) => {
          var t;
          m.stopPropagation(), (t = s.current) == null || t.prev();
        },
        "data-type": "previous",
        className: l.navigationButton,
        children: c && /* @__PURE__ */ o(c, { className: l.innerNavigationButton })
      }
    ),
    /* @__PURE__ */ o(
      "button",
      {
        onClick: (m) => {
          var t;
          m.stopPropagation(), (t = s.current) == null || t.next();
        },
        "data-type": "next",
        className: l.navigationButton,
        children: /* @__PURE__ */ o(p, { className: l.innerNavigationButton })
      }
    )
  ] }) });
}, G = j(
  "slider-dresden",
  k(D, ({ variants: r, children: h, features: l, content: a }) => {
    var v, g;
    const e = (l == null ? void 0 : l.navigationPlacement) || "slider", s = H.styles({
      ...r,
      navigationPlacement: e
    }), u = (l == null ? void 0 : l.headingTag) || "h3", c = ((v = l == null ? void 0 : l.icons) == null ? void 0 : v.previous) ?? T, p = ((g = l == null ? void 0 : l.icons) == null ? void 0 : g.next) ?? L, { currentSlide: m, sliderRef: t } = B(), w = A();
    return h ? /* @__PURE__ */ N("div", { className: s.base, children: [
      a && /* @__PURE__ */ N("div", { className: s.contentSection, children: [
        (a == null ? void 0 : a.heading) && /* @__PURE__ */ o(u, { className: s.heading, children: a.heading }),
        (a == null ? void 0 : a.link) && (a == null ? void 0 : a.linkLabel) && /* @__PURE__ */ o(w, { href: a == null ? void 0 : a.link.href, className: s.link, children: a == null ? void 0 : a.linkLabel }),
        /* @__PURE__ */ o(
          R,
          {
            previousIcon: c,
            nextIcon: p,
            slots: s,
            appearIn: e,
            location: "header"
          }
        )
      ] }),
      /* @__PURE__ */ N(
        "div",
        {
          ref: t,
          className: y("keen-slider", s.itemsWrapper),
          children: [
            /* @__PURE__ */ o(
              R,
              {
                previousIcon: c,
                nextIcon: p,
                slots: s,
                appearIn: e,
                location: "slider"
              }
            ),
            Array.from(h).map((b, n) => /* @__PURE__ */ o(
              "div",
              {
                className: y("keen-slider__slide", s.item),
                "data-is-featured": n === m ? "true" : "false",
                children: b
              },
              `${n}-dresden-item`
            ))
          ]
        }
      )
    ] }) : null;
  })
), S = {
  loop: !0,
  mode: "snap",
  breakpoints: {
    mobile: { perView: 1.25, spacing: 8 },
    tablet: { perView: 2, spacing: 8 },
    laptop: { perView: 3, spacing: 8 }
  }
}, f = i.object({
  children: i.custom().optional(),
  variants: i.custom().optional(),
  template: i.literal("sydney"),
  content: i.object({
    eyebrow: i.string().optional(),
    heading: i.string().optional(),
    description: i.string().optional(),
    tags: i.array(
      i.object({
        href: i.object({ href: i.string().optional() }).optional(),
        label: i.string().optional()
      })
    ).optional(),
    link: i.object({ href: i.string() }).optional(),
    linkLabel: i.string().optional()
  }).optional(),
  features: i.object({
    headingTag: i.union([
      i.literal("h1"),
      i.literal("h2"),
      i.literal("h3"),
      i.literal("h4"),
      i.literal("h5"),
      i.literal("h6")
    ]).optional(),
    icons: i.object({
      previous: i.custom().optional(),
      next: i.custom().optional()
    }).optional()
  }).optional()
}), U = j(
  "slider-sydney",
  k(f, ({ variants: r, children: h, features: l, content: a }) => {
    var g, b;
    const e = M.styles(r), s = (l == null ? void 0 : l.headingTag) || "h3", u = ((g = l == null ? void 0 : l.icons) == null ? void 0 : g.previous) ?? T, c = ((b = l == null ? void 0 : l.icons) == null ? void 0 : b.next) ?? L, { instanceRef: p, currentSlide: m, loaded: t, sliderRef: w } = B(), v = A();
    return h ? /* @__PURE__ */ N("div", { className: e.base, children: [
      a && /* @__PURE__ */ N("div", { className: e.upperSection, children: [
        (a == null ? void 0 : a.eyebrow) && /* @__PURE__ */ o("p", { className: e.eyebrow, children: a.eyebrow }),
        (a == null ? void 0 : a.heading) && /* @__PURE__ */ o(s, { className: e.heading, children: a == null ? void 0 : a.heading }),
        (a == null ? void 0 : a.tags) && /* @__PURE__ */ o("div", { className: e.tags, children: a.tags.map(({ href: n, label: d }, P) => /* @__PURE__ */ o(
          v,
          {
            className: e.tag,
            href: (n == null ? void 0 : n.href) ?? "",
            children: d
          },
          `tag-${P}`
        )) }),
        (a == null ? void 0 : a.description) && /* @__PURE__ */ o("p", { className: e.description, children: a.description })
      ] }),
      /* @__PURE__ */ N("div", { className: e.bottomSection, children: [
        (a == null ? void 0 : a.link) && /* @__PURE__ */ o(v, { href: a == null ? void 0 : a.link.href, className: e.link, children: a == null ? void 0 : a.linkLabel }),
        /* @__PURE__ */ o("div", { className: e.navigationButtonsWrapper, children: t && p.current && u && c && /* @__PURE__ */ N(_, { children: [
          /* @__PURE__ */ o(
            "button",
            {
              onClick: (n) => {
                var d;
                n.stopPropagation(), (d = p.current) == null || d.prev();
              },
              "data-type": "previous",
              "aria-label": "Previous Slide",
              className: e.navigationButton,
              children: u && /* @__PURE__ */ o(u, { className: e.innerNavigationButton })
            }
          ),
          /* @__PURE__ */ o(
            "button",
            {
              onClick: (n) => {
                var d;
                n.stopPropagation(), (d = p.current) == null || d.next();
              },
              "data-type": "next",
              "aria-label": "Next Slide",
              className: e.navigationButton,
              children: /* @__PURE__ */ o(c, { className: e.innerNavigationButton })
            }
          )
        ] }) })
      ] }),
      /* @__PURE__ */ o(
        "div",
        {
          ref: w,
          className: y("keen-slider", e.itemsWrapper),
          children: Array.from(h).map((n, d) => /* @__PURE__ */ o(
            "div",
            {
              className: y("keen-slider__slide", e.item),
              "data-is-featured": d === m ? "true" : "false",
              children: n
            },
            `${d}-sydney-item`
          ))
        }
      )
    ] }) : null;
  })
), V = i.union([D, f]), Y = k(V, (r) => {
  switch (r.template) {
    case "dresden":
      return /* @__PURE__ */ o(G, { ...r });
    case "sydney":
      return /* @__PURE__ */ o(U, { ...r });
    default:
      return null;
  }
}), z = "dresden", x = i.object({
  perView: i.number().or(i.literal("auto")),
  spacing: i.number()
}).optional(), K = i.object({
  mobile: x,
  tablet: x,
  laptop: x,
  desktop: x
}), q = i.object({
  mode: i.custom().optional(),
  loop: i.boolean().optional(),
  breakpoints: K.optional()
}), J = i.object({
  templateProps: V,
  children: i.custom(),
  sliderSettings: q.optional()
}), $ = I.createContext(void 0), B = () => {
  const r = I.useContext($);
  if (!r)
    throw new Error("useSliderContext must be used within a SliderContext");
  return r;
}, di = j(
  "Slider",
  k(J, (r) => {
    var v, g, b, n, d;
    const h = r.templateProps || {
      template: z
    }, l = r.sliderSettings ? r.sliderSettings : r.templateProps.template === "dresden" ? C : S, a = r.templateProps.template === "dresden" ? C.breakpoints : S.breakpoints, e = (v = r.sliderSettings) != null && v.breakpoints ? r.sliderSettings.breakpoints : a, [s, u] = E(0), [c, p] = E(!1), [m, t] = W({
      mode: (l == null ? void 0 : l.mode) ?? "snap",
      loop: (l == null ? void 0 : l.loop) ?? !0,
      breakpoints: {
        "(min-width: 0px)": {
          slides: {
            ...(e == null ? void 0 : e.mobile) ?? (e == null ? void 0 : e.tablet) ?? (e == null ? void 0 : e.laptop) ?? (e == null ? void 0 : e.desktop)
          }
        },
        "(min-width: 640px)": {
          slides: {
            ...(e == null ? void 0 : e.tablet) ?? (e == null ? void 0 : e.mobile) ?? (e == null ? void 0 : e.laptop) ?? (e == null ? void 0 : e.desktop)
          }
        },
        "(min-width: 1100px)": {
          slides: {
            ...(e == null ? void 0 : e.laptop) ?? (e == null ? void 0 : e.desktop) ?? (e == null ? void 0 : e.tablet) ?? (e == null ? void 0 : e.mobile)
          }
        },
        "(min-width: 1440px)": {
          slides: {
            ...((g = l == null ? void 0 : l.breakpoints) == null ? void 0 : g.desktop) ?? ((b = l == null ? void 0 : l.breakpoints) == null ? void 0 : b.laptop) ?? ((n = l == null ? void 0 : l.breakpoints) == null ? void 0 : n.tablet) ?? ((d = l == null ? void 0 : l.breakpoints) == null ? void 0 : d.mobile)
          }
        }
      },
      slideChanged(P) {
        u(P.track.details.rel);
      },
      created() {
        p(!0);
      }
    }), w = I.useMemo(
      () => ({
        instanceRef: t,
        loaded: c,
        sliderRef: m,
        currentSlide: s
      }),
      [t, c, m, s]
    );
    return /* @__PURE__ */ o($.Provider, { value: w, children: /* @__PURE__ */ o(Y, { ...h, children: r.children }) });
  })
);
export {
  C as DEFAULT_SLIDER_SETTINGS_TEMPLATE_DRESDEN,
  S as DEFAULT_SLIDER_SETTINGS_TEMPLATE_SYDNEY,
  Y as SelectTemplate,
  di as Slider,
  $ as SliderContext,
  G as SliderDresden,
  U as SliderSydney,
  K as breakpointSettings,
  D as sliderDresdenSchema,
  J as sliderPropsSchema,
  V as sliderSchema,
  q as sliderSettingsSchema,
  f as sliderSydneySchema,
  B as useSliderContext
};
//# sourceMappingURL=index.es.js.map
